import '~/js/views/weddings/includes/stickyNav';
import '~/js/views/weddings/includes/animated-modules';
import '~/js/views/general/about/includes/scroll-below';
import inspirationSlideList from '~/js/views/weddings/includes/inspirations-top-slide-list';
import inspirationsList from '~/js/views/weddings/includes/inspirations-list';
import 'slick-carousel';

const slickSlider = require('~/js/views/weddings/includes/slider-top');
const arrayOfResorts = [];
const arrayOfInspirations = [];
const inspirationName = document.querySelector('#inspirationName span:first-of-type');
const topSliderWrap = document.querySelector('.weddings-top .js-slick-slider-top');
let counter = 0;
let count = 0;
const cdnURL = '//cdn.sandals.com/sandals/v12';
const pinterest = document.querySelector('.share-pinterest.forIntroHeader');
const $slickSliderTop = $('.js-slick-slider-top');
const $slickSlider = $('#inspirationSlidesWrap');
const instagramDots = require('~/js/views/weddings/includes/navDots');

$slickSliderTop.on('init', () => {
    const dotsWrap = document.querySelector('.weddings-top .slick-dots');
    const dots = Array.from(dotsWrap.querySelectorAll('li'));

    if (dots.length > 5) {
        dots.forEach((dot, index) => {
            if (index <= 2) {
                dot.classList.add('large');
            } else if (index === 3) {
                dot.classList.add('semi');
            } else if (index === 4) {
                dot.classList.add('small');
            } else {
                dot.classList.add('none');
            }
        });
        instagramDots(dotsWrap, $slickSliderTop);
    }
});

$slickSlider.on('init', () => {
    const dotsWrap = document.querySelector('#inspirationSlidesWrap .slick-dots');
    const dots = Array.from(dotsWrap.querySelectorAll('li'));

    if (dots.length > 5) {
        dots.forEach((dot, index) => {
            if (index <= 2) {
                dot.classList.add('large');
            } else if (index === 3) {
                dot.classList.add('semi');
            } else if (index === 4) {
                dot.classList.add('small');
            } else {
                dot.classList.add('none');
            }
        });
        instagramDots(dotsWrap, $slickSlider);
    }
});


inspirationSlideList.inspirations.forEach((inspiration, index, array) => {
    arrayOfResorts.push(`
        <div class='slider-item'>
            <div class='slider-item-inner' data-bg='${inspiration.img}'>
                <div class='slider-text container'>
                    <div class='title'>
                        <h1>Be Inspired</h1>
                        <h4>Create Your Own Copyright!</h4>
                    </div>
                </div>
                <div class='container location-text-wrap'>
                    <div class='slider-location'>
                        <span class="arrow-up"></span><span>Inspiration: ${inspiration.name}</span>
                    </div>
                </div>
            </div>
        </div>`);
    counter++;
    if (counter === array.length) {
        topSliderWrap.innerHTML = arrayOfResorts.join('');
        $slickSliderTop.on('afterChange', (event, slick, currentSlide) => {
            let currentSlideImage = slick.$slides[currentSlide].children[0].getAttribute('data-bg');
            let imageName;

            if (currentSlideImage === null) {
                currentSlideImage = slick.$slides[currentSlide].children[0].style.backgroundImage;
                imageName = currentSlideImage.split('/')[currentSlideImage.split('/').length - 1].replace('.jpg\")', '');
            } else {
                imageName = currentSlideImage.split('/')[currentSlideImage.split('/').length - 1].replace('.jpg', '');
            }
            pinterest.setAttribute('href', `http://www.pinterest.com/pin/create/button/?url=${window.location.href}&media=http:${cdnURL}/images/weddings/inspirations/pinterest/${imageName}.jpg&description=Sandals%20Resorts%20Weddings%20%7C%20${inspiration.name}%20Inspiration`);
        });
        slickSlider();
    }
});


inspirationsList.inspirations.forEach((inspiration, index, array) => {
    if (index !== 0) {
        arrayOfInspirations.push(`
            <div class='inspirationSlide'>
                <p class='inspired'>inspired by <span>${inspiration.inspiredBy}</span></p>
                <a href='http://www.pinterest.com/pin/create/button/?url=https://www.sandals.com/weddings/inspirations/&media=${inspiration.ceremonyImg}&description=Sandals%20Resorts%20Weddings%20%7C%20${inspiration.name}%20Inspiration' rel="nofollow" class="share-pinterest forIntroHeader" data-pin-custom="true" target="_blank"><i class="ic ic-pinterest"></i></a>
                <img class='js-lazy object-fit ceremony' src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src='${inspiration.ceremonyImg}' />
                <img class='js-lazy object-fit reception inactive' src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src='${inspiration.receptionImg}' />
            </div>`);
    }
    count++;
    if (count === array.length) {
        const slideCounter = document.querySelector('#inspirationInfo .count');

        $('#inspirationSlidesWrap').append(arrayOfInspirations.join(''));

        $slickSlider.on('init reinit', (event, slick) => {
            const firstSlide = slick.$slides[0];
            const slideImages = Array.from(firstSlide.getElementsByClassName('js-lazy'));

            slideImages.forEach(image => {
                image.src = image.getAttribute('data-src');
            });
        });

        $slickSlider.slick({
            centerMode: true,
            centerPadding: '0',
            cssEase: 'linear',
            fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: $('.js-prev-slide-in-slider-top1'),
            nextArrow: $('.js-next-slide-in-slider-top1'),
            dots: true,
            appendDots: $('#inspirationSlidesWrap')
        });


        $slickSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const upcomingSlide = slick.$slides[nextSlide];
            const slideImages = Array.from(upcomingSlide.getElementsByClassName('js-lazy'));

            inspirationName.innerHTML = `${inspirationsList.inspirations[nextSlide].name}&nbsp;`;

            slideImages.forEach(image => {
                image.src = image.getAttribute('data-src');
            });
        });

        $slickSlider.on('afterChange', (event, slick, currentSlide) => {
            const i = (currentSlide ? currentSlide : 0) + 1;
            const link = document.querySelector('#link-wrap a');

            slideCounter.innerHTML = `${i}/${slick.slideCount}`;
            link.href = `/en/weddings/ideas/collection-details/?inspirationId=${inspirationsList.inspirations[currentSlide].id}`;
        });
    }
});

const weddingActiveTabCover = document.querySelector('.weddingTabs .activeTabNav');
const weddingActiveTab = document.querySelector('.weddingTabs li.active');

weddingActiveTabCover.style.width = `${weddingActiveTab.offsetWidth}px`;
weddingActiveTabCover.style.left = `${weddingActiveTab.offsetLeft}px`;

const showActiveTab = (target) => {
    if (target.tagName === 'SPAN') {
        target = target.parentElement;
    }

    const event = target.getAttribute('data-country');
    const slideWrap = document.getElementById('inspirationSlidesWrap');
    const slides = Array.from(slideWrap.querySelectorAll('.inspirationSlide'));
    const eventType = document.getElementById('eventType');
    const ceremonyReception = document.getElementById('ceremonyReception');
    const freeWedding = document.getElementById('freeWedding');
    const linkWrap = document.getElementById('link-wrap');

    weddingActiveTabCover.style.left = `${target.offsetLeft}px`;
    document.querySelector('.weddingTabs li.active').classList.remove('active');
    target.classList.add('active');

    if (event === 'ceremony' || event === 'reception') {
        if (event === 'ceremony') {
            slides.forEach((slide, index) => {
                slide.querySelector('img.reception').classList.add('inactive');
                slide.querySelector('img.ceremony').classList.remove('inactive');
                slide.querySelector('a').href = `http://www.pinterest.com/pin/create/button/?url=https://www.sandals.com/weddings/inspirations/&media=${inspirationsList.inspirations[index].ceremonyImg}&description=Sandals%20Resorts%20Weddings%20%7C%20${inspirationsList.inspirations[index].name}%20Inspiration`;
            });
            eventType.innerHTML = 'Ceremony';
        } else if (event === 'reception') {
            slides.forEach((slide, index) => {
                slide.querySelector('img.ceremony').classList.add('inactive');
                slide.querySelector('img.reception').classList.remove('inactive');
                slide.querySelector('a').href = `http://www.pinterest.com/pin/create/button/?url=https://www.sandals.com/weddings/inspirations/&media=${inspirationsList.inspirations[index].receptionImg}&description=Sandals%20Resorts%20Weddings%20%7C%20${inspirationsList.inspirations[index].name}%20Inspiration`;
            });
            eventType.innerHTML = 'Reception';
        }
        ceremonyReception.classList.remove('inactive');
        linkWrap.classList.remove('inactive');
        freeWedding.classList.add('inactive');
    } else if (event === 'free') {
        freeWedding.classList.remove('inactive');
        linkWrap.classList.add('inactive');
        ceremonyReception.classList.add('inactive');
    }
};

const weddingTabs = _.debounce(() => {
    weddingActiveTabCover.style.width = `${document.querySelector('.weddingTabs li.active').offsetWidth}px`;
    weddingActiveTabCover.style.left = `${document.querySelector('.weddingTabs li.active').offsetLeft}px`;
}, 300);

window.addEventListener('resize', weddingTabs);

document.onclick = (event) => {
    const target = event.target;

    if (!Element.prototype.matches) {
        if (target.webkitMatchesSelector) {
            target.matches = target.webkitMatchesSelector;
        }

        if (target.msMatchesSelector) {
            target.matches = target.msMatchesSelector;
        }

        if (target.mozMatchesSelector) {
            target.matches = target.mozMatchesSelector;
        }
    }

    if (target.matches('.locationTab, .locationTab *') && !target.matches('.active')) {
        showActiveTab(target);

        return false;
    }
};
